export default __webpack_public_path__ + "static/accountantsBanner-d263e70faff5d2f8e5dba18cfc5028b9.png";